import { Primary, Secondary, Text, TextLink } from '@cinch-labs/design-system'
import FocusLock from 'react-focus-lock'
import { CookieBannerProps } from '../../cookie-consent.types'
import styles from './cookie-banner.module.css'
import { datadogRum } from '@datadog/browser-rum'

const CookieBanner: React.FC<CookieBannerProps> = ({
  handleManageSettingsButtonClick,
  handleAcceptCookiesButtonClick,
  isPreferencesModalOpen,
  hydrated,
}) => (
  <FocusLock noFocusGuards disabled={isPreferencesModalOpen}>
    <div
      id="cookie-banner"
      role="dialog"
      className={styles.cookieBanner}
      data-testid={hydrated ? 'cookie-banner' : ''}
      aria-labelledby="cookie-banner-text"
    >
      <div className={styles.cookieBannerInner}>
        <div className={styles.cookieBannerContent}>
          <Text
            element="h2"
            fontSize="xxl"
            fontWeight="bold"
            lineHeight="display"
            className={styles.cookieBannerTitle}
          >
            Your privacy on cinch
          </Text>
          <Text id="cookie-banner-text" fontSize="s">
            Essential cookies make our site work, and analytical cookies help us
            understand your on-site journey so you can cinch it every time.
            Advertising and targeting cookies are only set if you accept them,
            so it’s completely up to you. Read our{' '}
            <TextLink
              className={styles.linkText}
              href="/policies/cookie-policy"
              target="_blank"
              hasNoLine
              textProps={{ fontSize: 's' }}
            >
              cookie policy
            </TextLink>{' '}
            or{' '}
            <TextLink
              data-testid="edit-preferences-button"
              onClick={(event) => {
                event.preventDefault()
                datadogRum.addAction('Cookie banner manage settings click')
                handleManageSettingsButtonClick &&
                  handleManageSettingsButtonClick()
              }}
              className={styles.linkText}
              href="/manage-cookies"
              hasNoLine
              textProps={{ fontSize: 's' }}
            >
              manage cookies
            </TextLink>{' '}
            at any time.
          </Text>
        </div>
        <div className={styles.cookieBannerButtons}>
          <Primary
            isFullWidth
            data-testid="accept"
            size="large"
            onClick={(event) => {
              event.preventDefault()
              datadogRum.addAction('Cookie banner accept click')
              localStorage.setItem('cookieConsentPreferences', 'true')
              handleAcceptCookiesButtonClick &&
                handleAcceptCookiesButtonClick(true)
            }}
          >
            Accept
          </Primary>

          <Secondary
            isFullWidth
            data-testid="decline"
            size="large"
            onClick={(event) => {
              event.preventDefault()
              datadogRum.addAction('Cookie banner essential only click')
              localStorage.setItem('cookieConsentPreferences', 'false')
              handleAcceptCookiesButtonClick?.(false)
            }}
          >
            Decline
          </Secondary>
        </div>
      </div>
    </div>
  </FocusLock>
)

export default CookieBanner
